import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { APP_PATHS } from '../constants/app-routes';
import { canAccessRouteAdminPanel } from '../constants/roles';
import { AuthService } from '../services/auth.service';

export const routeAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.getToken()) {
    return router.createUrlTree([APP_PATHS.login]);
  }

  if (canAccessRouteAdminPanel(auth.user()?.role)) {
    return true;
  }

  return auth.loadProfile().pipe(
    map((user) =>
      canAccessRouteAdminPanel(user?.role) ? true : router.createUrlTree([APP_PATHS.myRoute])
    )
  );
};
